export default {
    ADMIN_LIST_REQUEST : "ADMIN_LIST_REQUEST",
    ADMIN_LIST_SUCCESS : "ADMIN_LIST_SUCCESS",
    ADMIN_LIST_FAILURE : "ADMIN_LIST_FAILURE",
    GROUP_ADMIN_REQUEST: "GROUP_ADMIN_REQUEST",
    GROUP_ADMIN_SUCCESS: "GROUP_ADMIN_SUCCESS",
    ACTION_ADMIN_ADD: "ACTION_ADMIN_ADD",
    FILTER_ADMIN_PAGINATION : "FILTER_ADMIN_PAGINATION",
}